const IS_LOGGED_IN_GET = 'IS_LOGGED_IN_GET';
const IS_LOGGED_IN_TRUE = 'IS_LOGGED_IN_TRUE';
const IS_LOGGED_IN_FALSE = 'IS_LOGGED_IN_FALSE';
const SHOULD_REDIRECT = 'SHOULD_REDIRECT';

const getIsLoggedIn = () => ({
  type: IS_LOGGED_IN_GET
});

const userIsAuthorized = () => ({
  type: IS_LOGGED_IN_TRUE
});

const userIsUnauthorized = () => ({
  type: IS_LOGGED_IN_FALSE
});

const shouldRedirect = (logged) => ({
  type: SHOULD_REDIRECT,
  logged
});

export {
  IS_LOGGED_IN_GET,
  IS_LOGGED_IN_FALSE,
  IS_LOGGED_IN_TRUE,
  SHOULD_REDIRECT,
  shouldRedirect,
  getIsLoggedIn,
  userIsAuthorized,
  userIsUnauthorized
};
